import styled from 'styled-components';

export const Wrapper = styled.div`
  position: sticky;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: auto;

  background: #fff;
  bottom: 0;

  border-radius: 0px 0px 6px 6px;
  border-top: 1px solid #e1e1e1;

  padding: 12px ${p => p.theme.app.padding.horizontal};
`;
